import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as intlActions from "../intl/intlActions";
import { BSModal, PublicPage } from "../common";
import * as personalDataAction from "./personalDataAction";
import { HAS_PERSONAL_DATA_FORM, AUTHENTICATE_MEMBER } from "./personalDataModels";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import PersonalDataForm from "./PersonalDataForm";
import { formValueSelector } from "redux-form";
import { toast } from "react-toastify";

class PersonalDataPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            clientHasPersonalForm: false,
            configMessage: null,
            certificateAndEmailValidated: false,
            showErrorModal: false,
            errorModalMessage: null,
            blockSubmit: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.resetEmailValidation = this.resetEmailValidation.bind(this);
        this.recallCodeCheck = this.recallCodeCheck.bind(this);
        this.setBlockSubmit = this.setBlockSubmit.bind(this);
    }

    componentWillMount() {
        const { intlActions, languageCode, clientDesignator, personalDataActions } = this.props;
        intlActions.setLocale(languageCode);

        let model = HAS_PERSONAL_DATA_FORM(clientDesignator);
        personalDataActions.getItem(model);
    }

    componentDidUpdate(prevProps) {
        const { hasPersonalDataForm, personalDataFormData } = this.props;

        if (prevProps.hasPersonalDataForm !== hasPersonalDataForm && hasPersonalDataForm) {
            let configMessage = "";
            if (personalDataFormData.hasOwnProperty("localizations")) {
                if (personalDataFormData.hasPersonalDataFormMessage) {
                    configMessage = personalDataFormData["localizations"];
                }
            }
            this.setState({
                clientHasPersonalForm: hasPersonalDataForm,
                configMessage: configMessage,
            });
        }
    }

    recallCodeCheck(e) {
        e.preventDefault();
        const { personalDataActions, existingEmail, memberIdentifier, clientDesignator, languageCode } = this.props;
        const model = AUTHENTICATE_MEMBER(clientDesignator);
        personalDataActions.get(model, { existingEmail, memberIdentifier, languageCode }).then((res) => {
            if (res.payload.error) {
                toast(<FormattedMessage id="personalData.form.checkCodeTimeError" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
            }
        });
    }

    handleSubmit(formValues) {
        this.setState({ blockSubmit: true });
        const { personalDataActions, clientDesignator, languageCode } = this.props;
        const model = AUTHENTICATE_MEMBER(clientDesignator);
        personalDataActions.get(model, { ...formValues, languageCode }).then((res) => {
            if (!res.payload.error) {
                /**
                 * If we don't get an error response, we know that the user received the verification code email.
                 */
                this.setState({ certificateAndEmailValidated: true });
            } else if (res.payload.error.data.error === "recurringCodeRequest") {
                toast(<FormattedMessage id="personalData.form.checkCodeTimeError" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
                this.setState({ blockSubmit: false });
            } else {
                this.openErrorModal(<FormattedHTMLMessage id="personalData.form.unknownMemberErr" />);
                this.setState({ blockSubmit: false });
            }
        });
    }

    resetEmailValidation() {
        this.setState({ certificateAndEmailValidated: false });
    }

    setBlockSubmit(value) {
        this.setState({ blockSubmit: value });
    }

    renderErrorModal() {
        return (
            <BSModal
                backdrop={false}
                show={this.state.showErrorModal}
                closeButtonKey="common.cancel"
                onClose={() => this.setState({ showErrorModal: false })}
                title={
                    <span>
                        <FormattedMessage id="personalData.form.attention">
                            {this.renderFormatedMessage}
                        </FormattedMessage>
                    </span>
                }
            >
                <span>{this.state.errorModalMessage}</span>
            </BSModal>
        );
    }

    openErrorModal(message) {
        this.setState({ showErrorModal: true, errorModalMessage: message });
    }

    renderFormatedMessage(icon) {
        return <span className="icon warning">{icon}</span>;
    }

    render() {
        const { clientDesignator, languageCode, clientName } = this.props;
        const { clientHasPersonalForm, configMessage, certificateAndEmailValidated, blockSubmit } = this.state;

        /** If configMessage === null, then the request in componentDidMount did not succeed. After the request, if user has no configMessage,
         * the state is set to an empty string.
         */

        let otherLang = "donnees";
        let linkLabel = "FR";
        switch (languageCode) {
            case "fr-CA": {
                otherLang = "data";
                linkLabel = "EN";
            }
        }

        const languageSwitch = <a href={`/${otherLang}/${clientDesignator}`}>{linkLabel}</a>;

        return (
            <PublicPage clientDesignator={clientName} languageSwitch={languageSwitch} pageExists={true}>
                {clientHasPersonalForm && configMessage != null ? (
                    <PersonalDataForm
                        ref="form"
                        onSubmit={this.handleSubmit}
                        resetEmailValidation={this.resetEmailValidation}
                        certificateAndEmailValidated={certificateAndEmailValidated}
                        configMessage={!configMessage ? configMessage : configMessage[languageCode]["configMessage"]}
                        languageCode={languageCode}
                        recallCodeCheck={this.recallCodeCheck}
                        clientDesignator={clientDesignator}
                        blockSubmit={blockSubmit}
                        setBlockSubmit={this.setBlockSubmit}
                    />
                ) : (
                    <FormattedMessage id="personalData.form.noFormAvailable" />
                )}

                {this.renderErrorModal()}
            </PublicPage>
        );
    }
}

PersonalDataPage.propTypes = {
    personalDataActions: PropTypes.object,
    personalDataFormData: PropTypes.object,
    clientDesignator: PropTypes.string,
    hasPersonalDataForm: PropTypes.bool,
    clientName: PropTypes.string,
    existingEmail: PropTypes.string,
    intlActions: PropTypes.object,
    languageCode: PropTypes.string,
    memberIdentifier: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
    const languageCode = ownProps.params.languageCode;
    const personalDataForm = state.personalData.hasPersonalDataForm;

    const mainForm = formValueSelector("personalDataForm");

    return {
        languageCode,
        clientDesignator: ownProps.params.clientDesignator,
        hasPersonalDataForm: personalDataForm ? personalDataForm.hasPersonalDataForm : false,
        clientName: personalDataForm ? personalDataForm.name : "",
        personalDataFormData: personalDataForm,
        memberIdentifier: mainForm(state, "memberIdentifier"),
        existingEmail: mainForm(state, "existingEmail"),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        intlActions: bindActionCreators(intlActions, dispatch),
        personalDataActions: bindActionCreators(personalDataAction, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDataPage);



// WEBPACK FOOTER //
// ./src/components/personal-data/PersonalDataPage.js